import React, { useState } from 'react';
import { Tab, Tabs, Row, Col, Container } from 'react-bootstrap';
import '../styles/skills.css';

const programmingIcons = [
  { name: 'Java', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg' },
  { name: 'JavaScript', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
  { name: 'C++', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg' },
  { name: 'C', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg' },
  { name: 'Python', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
  { name: 'Go', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original.svg' },
  { name: 'Rust', url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUOXxrZKyfxqjRdoWnY_x3zfm9FbbzLmhxNw&s' },
  { name: 'Dart', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg' },
  { name: 'R', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/r/r-original.svg' },
  { name: 'Scala', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/scala/scala-original.svg' },
  { name: 'MATLAB', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/matlab/matlab-original.svg' },
  { name: 'Swift', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg' },
  { name: 'Kotlin', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg' },
];
const blockchainIcons = [
  { name: 'Solidity', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/solidity/solidity-original.svg' },
  { name: 'Ethereum', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Ethereum_logo_2014.svg/1200px-Ethereum_logo_2014.svg.png' },
  { name: 'Ganache', url: 'https://logowik.com/content/uploads/images/ganache-blockchain5516.logowik.com.webp' },
  { name: 'Hyperledger', url: 'https://www.ledgerinsights.com/wp-content/uploads/2020/01/hyperledger-fabric.jpg' },
  { name: 'Truffle', url: 'https://archive.trufflesuite.com/img/blog/thumbnails/truffle.png' },
  { name: 'MetaMask', url: 'https://blogs.airdropalert.com/wp-content/uploads/2018/10/metamask_featured.jpg' },
  { name: 'Remix', url: 'https://pbs.twimg.com/profile_images/1477703417636163586/fuv2rwTA_400x400.jpg' },
];

const dataScienceIcons = [
  { name: 'TensorFlow', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg' },
  { name: 'NumPy', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg' },
  { name: 'Pandas', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg' },
  { name: 'PyTorch', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg' },
 

//{name:'', url:''},
{name:'PowerBi', url:'https://ml2quantum.com/wp-content/uploads/2020/05/Microsoft-Power-BI-Symbol.png'},
{name:'Tableau', url:'https://mma.prnewswire.com/media/411941/TABLEAU_SOFTWARE_LOGOjpg_Logo.jpg?p=facebook'},
{name:'SeaBorn', url:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2NlF-TJs7t4xv02opfzaBDvPrnDTiwDbdLg&s'},

];

const devOpsIcons = [
  { name: 'GitHub', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg' },
  { name: 'Docker', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
  { name: 'Jenkins', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg' },
  { name: 'Terraform', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg' },
  { name: 'Kubernetes', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-original.svg' },
   {name:'Ansible', url:'https://upload.wikimedia.org/wikipedia/commons/0/05/Ansible_Logo.png'},
     {name:'GitLab', url:'https://static-00.iconduck.com/assets.00/gitlab-original-wordmark-icon-256x255-5by1gtgp.png'},
];

const cloudIcons = [
  { name: 'AWS', url: 'https://logos-world.net/wp-content/uploads/2021/08/Amazon-Web-Services-AWS-Logo.png' },
  { name: 'Google Cloud', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg' },
];

const quantumIcons = [
  { name: 'Qiskit', url: 'https://logowik.com/content/uploads/images/qiskit9093.logowik.com.webp' },
  { name: 'IBM Quantum', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/IBM_logo.svg/1200px-IBM_logo.svg.png' },
];

// Added Icons
const databaseIcons = [
  { name: 'MySQL', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
  { name: 'PostgreSQL', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
  { name: 'MongoDB', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
  { name: 'SQLite', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg' },
  {name:'GraphQL', url:'https://i.pinimg.com/736x/66/ec/d4/66ecd45c7b6a7a76cd3c2c1e16b14ea0.jpg'},
{name:'Firebase', url:'https://firebase.google.com/static/images/brand-guidelines/logo-vertical.png'},
];

const aimlIcons = [ 
{ name: 'TensorFlow', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg' },
{ name: 'PyTorch', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg' },
{ name: 'Keras', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/keras/keras-original.svg' },
{ name: 'Scikit-learn', url: 'https://e7.pngegg.com/pngimages/39/4/png-clipart-logo-scikit-learn-python-github-machine-learning-text-orange.png' },
{ name: 'Pandas', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg' },
{ name: 'NumPy', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg' },
{ name: 'OpenCV', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opencv/opencv-original.svg' },
];

const bigDataIcons = [
  { name: 'Apache Hadoop', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/hadoop/hadoop-original.svg' },
  { name: 'Apache Spark', url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQk8KLrz1OYfFRDTNayIdRwdanvCy0_Jk8ajg&s' },
  { name: 'Apache Kafka', url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDCsnH-LecjXUO0ujaEgMSALxOVGEf_7KSZA&s' },
  { name: 'Elasticsearch', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/elasticsearch/elasticsearch-original.svg' },
  { name: 'D3.js', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/d3js/d3js-original.svg' },
  { name: 'Snowflake', url: 'https://miro.medium.com/v2/resize:fit:830/1*utRpKgvH_g5z1ePHWaaAuQ.png' },
{name:'rapidMiner', url:'https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/technical%20skills%20logos%2Frapidminer.png?alt=media&token=20bb84ca-524e-4848-b727-b0feaf7b2a82'},
{name:'SAS', url:'https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/technical%20skills%20logos%2Fsas.svg?alt=media&token=33cec9c7-268c-4ae1-a787-a0f04792016f'},
{name:'Knime', url:'https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/technical%20skills%20logos%2Fknime.png?alt=media&token=6c8e8511-79f3-407d-acd2-aaa8ac46632b'},
{name:'BigMl', url:'https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/technical%20skills%20logos%2Fbigml.jpeg?alt=media&token=5c980385-1420-46a1-a3b0-1be72acd31e4'},
{name:'NLP', url:'https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/technical%20skills%20logos%2Fnlp.svg?alt=media&token=a217f8e1-9136-4aac-8fbc-f15d4de47546'},

];
const geologyIcons = [

  { name: 'ArcGIS', url: 'https://icon2.cleanpng.com/20190113/ttl/kisspng-arcgis-geographic-information-system-esri-canada-g-1713909409930.webp' },
  { name: 'QGIS', url: 'https://qgis.org/styleguide/visual/main_logo.png' },
  { name: 'Google Earth', url: 'https://w7.pngwing.com/pngs/124/998/png-transparent-google-earth-icon-hd-logo-thumbnail.png' },
  { name: 'Surfer', url: 'https://5.imimg.com/data5/SELLER/Default/2023/9/345737000/AJ/DI/CJ/3162855/surfer-software-500x500.jpeg' },
  { name: 'Petrel', url: 'https://iconape.com/wp-content/files/bg/191205/svg/191205.svg' },
];

const uifrontendIcons = [
{name:'Figma', url:'https://i.pinimg.com/736x/a5/58/b4/a558b426cb8973523f37bbed94cf0f09.jpg'},
{name:'AdobeXd', url:'https://www.logo.wine/a/logo/Adobe_XD/Adobe_XD-Logo.wine.svg'},
{name:'ReactJs', url:'https://cdn.vectorstock.com/i/500p/78/57/react-icon-in-a-hexagon-vector-36587857.jpg'},
{name:'Flutter', url:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRf_Mr-72O-rzoa5Kxu6zlmuvA9S2aPJ_9eTtxXKmPzdgCvxkIp8meH2LuVLhBAqadLxwo&usqp=CAU'},
{name:'Actix-Web', url:'https://miro.medium.com/v2/resize:fit:565/1*n7G-rZKXlkbjnqm41DRsaw.jpeg'},
{name:'Yew-Rust', url:'https://yew.rs/img/logo.png'},
{name:'NextJs', url:'https://images.prismic.io/turing/652ec31afbd9a45bcec81965_Top_Features_in_Next_js_13_7f9a32190f.webp?auto=format,compress'},
//{name:'', url:''},

];


const TabComponent = () => {
  const [key, setKey] = useState('all');

  const renderIcons = (icons) => (
    <Row className="mt-2 justify-content-center">
      {icons.map((icon, index) => (
        <Col key={index} xs={4} sm={3} md={2} lg={1.5} className="text-center mb-1">
          <img
            src={icon.url}
            alt={icon.name}
            style={{ width: '60px', height: '60px', objectFit: 'contain' }}
          />
          <p>{icon.name}</p>
        </Col>
      ))}
    </Row>
  );

  return (
    <Container className="mt-5">
    <h2 className="text-center mb-1 text-black fw-bold">Technical Skills</h2>
    <div className="tabs-container bg-white text-dark p-5" style={{ borderRadius: '10px', width: '100%', margin: '0 auto' }}>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3 justify-content-center"
        variant="pills"
      >
        <Tab eventKey="all" title="All">
          {renderIcons([...programmingIcons, ...dataScienceIcons, ...devOpsIcons, ...cloudIcons, ...quantumIcons, ...databaseIcons, ...aimlIcons, ...bigDataIcons])}
        </Tab>
        <Tab eventKey="programming" title="Programming Lang">
          {renderIcons(programmingIcons)}
        </Tab>
        <Tab eventKey="Ui/UX & FrontEnd" title="UI/UX & FrontEnd Tools">
          {renderIcons(uifrontendIcons)}
        </Tab>
        <Tab eventKey="geology" title="Geology & GeoPhysics">
          {renderIcons(geologyIcons)}
        </Tab>
        <Tab eventKey="blockchain" title="BlockChain">
          {renderIcons(blockchainIcons)}
        </Tab>
        <Tab eventKey="datascience" title="Data Science & Business Analyst">
          {renderIcons(dataScienceIcons)}
        </Tab>
        <Tab eventKey="aiml" title="AI & ML">
          {renderIcons(aimlIcons)}
        </Tab>
        <Tab eventKey="databases" title="Databases">
          {renderIcons(databaseIcons)}
        </Tab>
        <Tab eventKey="bigdata" title="Big Data Engineering">
          {renderIcons(bigDataIcons)}
        </Tab>
        <Tab eventKey="devops" title="DevOps">
          {renderIcons(devOpsIcons)}
        </Tab>
        <Tab eventKey="cloud" title="Cloud Services">
          {renderIcons(cloudIcons)}
        </Tab>
        <Tab eventKey="quantum" title="Quantum Computing">
          {renderIcons(quantumIcons)}
        </Tab>
      </Tabs>
    </div>
  </Container>
  );
};

export default TabComponent;
